export default __webpack_public_path__ + "static/media/alta-alella-vineyards.f59c46ed.jpg";